<template>
  <div>
    <b-row
      v-if="item && Object.keys(item).length"
      class="mx-md-0 p-md-3 pt-3 mt-md-0 mt-3"
    >
      <b-col
        v-if="pathOr(false, ['ticket_finished'], item)"
        cols="12"
        md="12"
        class="p-3 mb-3 bg_alert text-white rounded text-center"
        v-text="$lang.ticketLang.cant_edit_ticket"
      />
      <b-col cols="12" md="12">
        <b-row align-v="center" align-h="between" class="mb-3">
          <b-col
            cols=""
            md=""
            class="font_18 font_weight_bold color_second"
            v-text="pathOr(null, ['ticket_subject'], item)"
          />
          <b-col
            v-if="accessLevel === 'user'"
            cols="auto"
            md="auto"
            :class="`badge_style badge_style--${pathOr(
              'danger',
              ['ticket_status_id', 'color'],
              item
            )}`"
            v-text="pathOr('', ['ticket_status_id', 'caption'], item)"
          />
        </b-row>
        <b-row class="bg-white rounded-0">
          <b-col cols="12" md="12" class="px-0">
            <div
              v-for="(message, index) in pathOr([], ['details'], item)"
              :key="index"
              class="message-box mb-5 p-3"
              :class="`message-box--${getMessageType(message)}`"
            >
              <div class="flex_between mb-3">
                <span
                  class="font_weight_bold"
                  v-text="getSenderName(message)"
                />
                <span
                  v-text="
                    $moment(
                      pathOr(null, ['created_at', 'gregorian'], message)
                    ).format('jYYYY/jMM/jDD HH:mm')
                  "
                  class="dir_ltr"
                />
              </div>
              <p
                class="message-box__text"
                v-html="nl2br(pathOr('', ['description'], message))"
              />
              <div
                class="message-box__attachment"
                v-if="pathOr(null, ['has_attachment'], message)"
              >
                <mdicon name="attachment" size="16" />
                <span
                  class="ml-1"
                  v-b-tooltip.hover
                  :title="$lang.ticketLang.ticket_page.click_for_show_files"
                  v-text="$lang.ticketLang.ticket_page.show_files_attached"
                  @click="openModal(message)"
                />
              </div>
              <div
                class="message-box__seen"
                v-if="pathOr(null, ['user_seen_date', 'gregorian'], message)"
                v-b-tooltip.hover
                :title="$lang.ticketLang.ticket_page.visited_at"
              >
                <mdicon name="eye-check-outline" size="16" />
                <span
                  v-text="
                    $moment(
                      pathOr(null, ['user_seen_date', 'gregorian'], message)
                    ).format('jYYYY/jMM/jDD HH:mm')
                  "
                  class="ml-1 dir_ltr"
                />
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-modal
        no-close-on-backdrop
        variant="primary"
        header-bg-variant="primary"
        content-class="border-primary"
        v-model="viewModal"
        size="xl"
        ok-only
        hide-header
        hide-footer
      >
        <b-row>
          <b-col cols="12">
            <UploadFile
              v-if="file_id"
              caption="پیوست‌های درخواست"
              attachment_type_name="attachment_type_ticket"
              :attachmentRoute="attachmentRoute"
              keyServies="ticket_detail"
              :keyValue="file_id"
              :file_types="file_types"
              :customPermission="parentPermissions"
              :allowCollapse="false"
              :showForm="false"
              :crop="false"
              :showAdd="false"
              :outButton="outButton"
            />
          </b-col>
          <b-col cols="12" class="text-right pt-3">
            <b-button
              class="ml-2"
              size="md"
              variant="danger"
              @click="closeModal"
            >
              {{ $lang.close }}
              <i class="fa fa-ban" />
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
    </b-row>
    <b-row v-else>
      <b-col>
        <b-alert show variant="danger" class="font-weight-bold">
          <i class="fas fa-info-circle mr-2" />
          <span v-text="'هیچ اطلاعاتی وجود ندارد.'" />
        </b-alert>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import UploadFile from "@/components/base/uploadFile";
import { pathOr } from "ramda";
import { nl2br } from "@/shared/utils";

export default {
  name: "new-chat-box",
  props: {
    item: {
      type: Object,
      default: null,
    },
    accessLevel: {
      type: String,
      default: null,
    },
  },
  components: {
    UploadFile,
  },
  data() {
    return {
      parentPermissions: ["view"],
      file_types: ["image", "office"],
      viewModal: false,
      file_id: null,
      outButton: [
        {
          id: "1",
          name: "edit",
        },
        {
          id: "0",
          name: "delete",
        },
        {
          id: "2",
          name: "crop",
        },
        {
          id: "1",
          name: "download", // دانلود
          href: true,
        },
      ],
    };
  },
  computed: {
    attachmentRoute() {
      const code = pathOr(null, ["code"], this.item);
      return this.accessLevel === "user"
        ? "my-attachment-ticket"
        : `attachment-ticket/${code}`;
    },
  },
  methods: {
    pathOr,
    nl2br,
    getMessageType(messageData) {
      let type =
        pathOr(null, ["ticket_sender_group", "id"], messageData) === 1
          ? "user"
          : "support";
      if (this.accessLevel === "user") {
        type =
          pathOr(null, ["ticket_sender_group", "id"], messageData) === 1
            ? "support"
            : "user";
      }

      return type;
    },
    getSenderName(messageData) {
      let name =
        pathOr(null, ["ticket_sender_group", "id"], messageData) !== 1
          ? pathOr("", ["user", "name"], messageData)
          : "";
      if (this.accessLevel === "user") {
        name =
          pathOr(null, ["ticket_sender_group", "id"], messageData) !== 1
            ? "پشتیبان"
            : "";
      }

      return name;
    },
    closeModal() {
      this.file_id = null;
      this.viewModal = false;
    },
    openModal(detail) {
      this.file_id = pathOr(null, ["code"], detail);
      this.viewModal = true;
    },
  },
};
</script>
